import { ThemeProvider } from 'styled-components';
import { theme } from './main';

export const AppThemeProvider = ({ children }: any) => {
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}